<div class="step-indicator">
  @for (step of steps; track step; let i = $index; let last = $last) {
    <div class="step-container">
      <div
        class="step-circle"
        [class.completed]="isStepCompleted(i)"
        [class.current]="isStepCurrent(i)"
        [class.future]="isStepFuture(i)"
      >
        @if (isStepCompleted(i)) {
          <svg
            class="checkmark"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        } @else {
          <span class="step-number">{{ i + 1 }}</span>
        }
      </div>
      @if (!last) {
        <div class="connector" [class.completed]="isStepCompleted(i)"></div>
      }
    </div>
  }
</div>
